export default __webpack_public_path__ + "gt_retail.png";